// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"kwRKbV","card":"_3-EMxl","cardHeading":"HZEDxO","cartTitle":"_3LRHh8","cardSubtitle":"_3Nmz59","cardIcon":"_2M4g_E"};